/**
 *
 * TODO (mkosarek May 11, 2022)
 *
 * If you ever think to yourself, "It would be nice if we had all the same functionality in CAD but way better",
 * I have a branch for you: https://github.com/VentionCo/mm-machine-logic/tree/feature/2707
 *
 * The main feature of the above branch is that the 'machinemotion_mqtt.js' is Notification based. It is also
 * intended to serve more as an mqtt 'api' instead of just a vanilla mqtt client. In the same way that we abstract
 * the 'fetch's away from the end-user in machinemotion.js, this file will abstract the mqtt message processing
 * away from the end-user.
 *
 * Please use this after MultiController is finished, or I will be sad.
 *
 */
import { v4 as uuidv4 } from 'uuid';
import { MqttClient } from '@src/mqtt_browser';
import { estopManager } from './estop';
import { mmHost } from '@src/Main/main';

/** @type MqttClient */
let gClientInstance;

let gIsClientReady = false;
let gOnReadyCallbacks = {};

/**
 * Asynchronously initializes the mqttClient.
 * Any code trying to get the client will have its callback executed once the client is ready.
 *
 * @param {Navigate} navigate A function to navigate to another page.
 */
// TODO GD I don't like the singleton / global scope aspect of this, but for my refactor this saves me an immense amount of work.
// TODO GD Sorry ¯\_(ツ)_/¯
export function initClient (navigate) {
  gIsClientReady = false;
  console.log('MQTT connecting..');

  gClientInstance = new MqttClient(mmHost, 9001, () => {
    const lOnReadyCallbacks = Object.values(gOnReadyCallbacks);

    // NOTE: When we lose connection, we will have a new MQTT object.
    // NOTE: Meaning it will not have any of the subscription of the previous object.
    // NOTE: This might be not what you expect.
    console.log(`MQTT connection opened. Sending to ${lOnReadyCallbacks.length} waiting callbacks.`);
    gIsClientReady = true;

    lOnReadyCallbacks.forEach(callback => callback(gClientInstance));
    gOnReadyCallbacks = {};

    // TODO: This is an easy solution to inform the RemoteAccess about the MQTT connection status.
    // Ideally we would have the same way to deal with this for both RemoteAccess and Estop.
    const event = new CustomEvent('mqttClientEvent', { type: 'connection' });
    window.dispatchEvent(event);

    // SHOULD: the estopManager listen to this event as well, instead of a call?
    estopManager.listenToEstop(navigate);
  });
}

/**
 * Gets the initialized MQTT client once it is ready to be used.
 * You need to call 'initClient' at some point, otherwise it will never be ready.
 *
 * This function returns a cancellation function if you want to abort the operation.
 * Calling the cancellation function after getClient resolves will not cause any issue.
 *
 * @param {(MqttClient) => void} pOnReady A callback for when the client is ready.
 * @return {() => void} A cancellation function if you don't want the client anymore.
 */
// TODO GD The async nature of getClient is annoying to use
// TODO GD With the React structure, we could have initClient be a promise that resolves to the client, and pass it down as props / in the context
export function getClient (pOnReady) {
  if (!gClientInstance) {
    console.warn('[mqtt_instance] getClient was called before initClient. This is fine, but if initClient is never called, your callback will never be called.');
  }

  if (!gIsClientReady) {
    console.log('Waiting for initial connection to mqtt...');
    const requestId = uuidv4();
    gOnReadyCallbacks[requestId] = pOnReady;

    return () => delete gOnReadyCallbacks[requestId];
  }

  pOnReady(gClientInstance);

  // Nothing to clean up, request was not queued.
  return () => undefined;
}
